/**
 * Feature Flags Configuration
 * Single source of truth for all feature flags
 */

interface FeatureFlags {
    /** Enable using pre-calculated gold table for spark chart data */
    sparkChartBundle: boolean;
    /** Enable Market-wide Leaderboard spark type filter option */
    marketWideLeaderboard: boolean;
    /** Enable the Inventory V2 views (replaces the legacy inventory dashboard tab) */
    inventoryV2: boolean;
}

const parseFeatureFlags = (): FeatureFlags => {
    return {
        sparkChartBundle: import.meta.env.REACT_APP_SPARK_CHART_BUNDLE === 'true',
        marketWideLeaderboard: import.meta.env.REACT_APP_MARKET_WIDE_LEADERBOARD === 'true',
        inventoryV2: import.meta.env.REACT_APP_INVENTORY_V2 === 'true',
    };
};

export const featureFlags = parseFeatureFlags();

export const isSparkChartBundleEnabled = (): boolean => featureFlags.sparkChartBundle;
export const isMarketWideLeaderboardEnabled = (): boolean => featureFlags.marketWideLeaderboard;
export const isInventoryV2Enabled = (): boolean => featureFlags.inventoryV2;
export class FeatureDisabledError extends Error {
    constructor(featureName: string) {
        super(`Feature "${featureName}" is not enabled`);
        this.name = 'FeatureDisabledError';
    }
}
